<template>
  <b-modal
    title="Inserimento voto"
    class="modal-info registro"
    v-model="show1"
    ok-variant="danger"
    :ok-only="true"
    size="xl"
  >
    <div class="registro">
      Voto - Data
      <br />
      <input type="text" class="voto2" v-model="voto" />
      &nbsp;
      <datetime class="datavoto2" v-model="data" :max-datetime="adesso" :min-datetime="mindata()" @close="checkmsg()" :disabled="oldvoto"/>
      <br />
      <br />Oggetto:
      <input type="text" class="votooggetto" v-model="oggetto" style="width: 100%;" />
      <template v-if="ECFOP && progid">
        <br />
        <b>Abilità{{ selabil.length ? '' : ' (obbligatorie)' }}:</b>
        <span v-if="!selabil.length" class="text-danger">*</span>
        <div class="abilita-box" v-if="!loadingabil && abilita.length">
          <table class="abilita-tabella">
            <thead>
              <tr>
                <th class="abilita-area">Area</th>
                <th>Competenza</th>
                <th>Abilità</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in abilitaRighe" :key="r.ab.modabilid">
                <td v-if="r.rowspanArea" :rowspan="r.rowspanArea" class="abilita-area">{{ r.area }}</td>
                <td v-if="r.rowspanComp" :rowspan="r.rowspanComp" class="abilita-comp">{{ r.competenza }}</td>
                <td>
                  <label class="abilita-item" :class="{ 'abilita-cdr': r.ab.incdr }">
                    <input type="checkbox" :value="r.ab.modabilid" v-model="selabil" :disabled="readonly" />
                    <span v-if="r.ab.incdr" title="Presente nel C.D.R.">💡</span>
                    <span>{{ r.ab.abilita }}</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="loadingabil" class="text-muted">Caricamento abilità...</div>
        <div v-else class="text-muted">Nessuna abilità disponibile per questo progetto.</div>
      </template>
    </div>
    <hr />
    <table v-if="skills">
      <tr>
        <th colspan="2" rowspan="4" valign="top">SKILLS</th>
        <th colspan="4">LIVELLO di acquisizione</th>
      </tr>
      <tr>
        <th width="10%" class="punti1"></th>
        <th width="10%" class="punti2"></th>
        <th width="10%" class="punti3"></th>
        <th width="10%" class="punti4"></th>
      </tr>
      <tr>
        <th class="punti">Non è in grado di svolgere il compito</th>
        <th class="punti">Svolge compiti semplici applicando regole e procedure di base</th>
        <th
          class="punti"
        >Svolge compiti e risolve problemi complessi in situazioni note utilizzando le conoscenze e le abilità acquisite</th>
        <th
          class="punti"
        >Svolge compiti e risolve problemi complessi in situazione anche non note mostrando padronanza nell’uso delle conoscenze e delle abilità.</th>
      </tr>
      <tr>
        <th class="punti1">NULLO</th>
        <th class="punti2">BASE</th>
        <th class="punti3">INTERMEDIO</th>
        <th class="punti4">AVANZATO</th>
      </tr>
      <tr>
        <td width="15%">Autonomia</td>
        <td width="45%">Svolge i compiti assegnati senza bisogno di supervisione</td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="4">
        </td>
      </tr>
      <tr>
        <td>Organizzazione</td>
        <td>Identifica obiettivi e priorità e pianifica il processo tenendo conto del tempo a disposizione</td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="4">
        </td>
      </tr>
      <tr>
        <td>Precisione</td>
        <td>È accurato ed attento a ciò che fa e ne cura i dettagli</td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="4">
        </td>
      </tr>
      <tr>
        <td>Apprendimento</td>
        <td>Riconosce lacune ed aree di miglioramento e si attiva per migliorare</td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="4">
        </td>
      </tr>
      <tr>
        <td>Comunicazione</td>
        <td>Ascolta e in modo chiaro e sintetico trasmette informazioni e condivide idee con vari interlocutori</td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="4">
        </td>
      </tr>
      <tr>
        <td>Problem Solving</td>
        <td>Identifica priorità e criticità e individua le possibili migliori soluzioni ai problemi</td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="4">
        </td>
      </tr>
      <tr>
        <td>Team work</td>
        <td>Lavora e collabora positivamente con gli altri per eseguire il compito assegnato</td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="4">
        </td>
      </tr>
      <tr>
        <td>Leadership</td>
        <td>Conduce, motiva e trascina gli altri verso l'obiettivo definito</td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="4">
        </td>
      </tr>
    </table>
    <div slot="modal-footer" style="width: 100%;">
      <div style="float: left;">
        <button type="button" class="btn btn-danger" @click="show1=false">Annulla</button>
      </div>
      <div style="float: right;margin-left: 10px;">
        <button
          type="button"
          class="btn btn-info"
          @click="addvoto(false)"
          :disabled="!validvoto"
          title="Salva"
          v-if="!readonly && (!oldvoto || !hm)"
        >
          Salva
          <i class="fa fa-check"></i>
        </button>
      </div>
      <div style="float: right;margin-left: 10px;">
        <button
          type="button"
          class="btn btn-info"
          @click="addvoto(true)"
          :disabled="!validvotohome"
          title="Salva HOMEWORK"
          v-if="!readonly && (!oldvoto || hm) && dwhat.mid!=999999"
        >
          Salva
          <i class="fa fa-home"></i>
        </button>
      </div>
      <div style="clear: both;"></div>
    </div>
  </b-modal>
</template>
<script>
import { DateTime } from "luxon";
import { API } from "@/api.js";

export default {
  name: "InsVoto",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {
      show1: false,
      readonly: false,
      oldvoto: false,
      dwtempl: {
        // serve solo per definire l'oggetto
        voto: "",
        data: "",
        oggetto: "",
        selabil: [], // abilità collegate al voto (array di modabilid)
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
        data6: 0,
        data7: 0,
        data8: 0
      },
      dwhat: {
        voto: "",
        data: "",
        oggetto: "",
        selabil: [],
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
        data6: 0,
        data7: 0,
        data8: 0
      },
      voto: "",
      data: "",
      oggetto: "",
      selabil: [],
      // abilità disponibili per il progetto (ECFOP) — caricate da registro.selabilprog
      abilita: [],
      abilprogid: null,
      loadingabil: false,
      abiltoken: 0, // guardia anti-race per le risposte asincrone delle abilità
      data1: 0,
      data2: 0,
      data3: 0,
      data4: 0,
      data5: 0,
      data6: 0,
      data7: 0,
      data8: 0,
      // in base al valore vedo se rimostrare l'ultimo oggetto salvato
      lastOggetto: '',
      lastOggettoData: null,
      lastOggettoModulo: null,
      currMod: null,
    };
  },
  props: ["show", "value","skills", "progid"],
  mounted: async function() {
    console.log("INSVOTO mounted !!")
  },
  watch: {
    show: function(newVal, oldVal) {
      // watch it
      // console.log("Prop show changed: ", newVal, " | was: ", oldVal);
      this.show1 = newVal;
    },
    data: function(newVal, oldVal) {
      console.log("DATA changed!: ", newVal, " | was: ", oldVal,"?:",this.oggetto);
      if(this.lastOggettoData==newVal && this.currMod==this.lastOggettoModulo && !this.oldvoto)
        this.oggetto = this.lastOggetto
      else {
        // console.log("azzero oggetto")
        // this.oggetto = ''
      }
    },
    show1: function(newVal, oldVal) {
      // watch it
      // console.log("Prop show1 changed: ", newVal, " | was: ", oldVal);
      if (!newVal) {
        this.setdwhat();
        this.dwhat.cancel = true;
        this.$emit("input", this.dwhat); // questo emit si aggancia come v-model
      }
    },
    value: function(newVal, oldVal) {
      // watch it
      console.log("Prop value changed: ", newVal, " | was: ", oldVal);
      this.currMod = newVal.mid
      
      // console.log("!!!",newVal.ro)
      this.readonly = newVal.ro
      this.oldvoto = newVal.oldvoto || false
      this.hm = newVal.hm || false
      this.dwhat = Object.assign({}, newVal);
      this.getdwhat();

      // ECFOP: aggiorno le abilità per QUESTO voto (race-safe).
      // Uso un token: se arriva la risposta di un'apertura precedente la ignoro,
      // così un nuovo voto NON mostra mai le abilità del voto precedente.
      this.abiltoken = (this.abiltoken || 0) + 1;
      var tok = this.abiltoken;
      if (this.ECFOP && this.progid) {
        this.selabil = []; // azzero sempre alla riapertura
        this.loadabil(tok).then(() => {
          // preseleziono SOLO se sto modificando un voto esistente con una data
          if (tok !== this.abiltoken) return;
          if (!this.oldvoto || !this.data) return;
          var repls = { "@hm": this.dwhat.hm ? "hm" : "" };
          var d = this.data.split("T")[0];
          return API.sqlprep(this, "registro.selabilvoto", [this.dwhat.aid, this.dwhat.mid, d], repls)
            .then(ret => {
              if (tok !== this.abiltoken) return; // ignorato se nel frattempo cambiato
              this.selabil = (ret.data.dati || []).map(r => r.modabilid);
            });
        });
      }
    }
  },
  computed: {
    adesso: function() {
      return DateTime.local().plus({ days: 0 }).toISODate() + "T00:00:00Z"
    },
    validvoto: function() {
      var ok = !this.skills || this.data1 && this.data2 && this.data3 && this.data4 && this.data5 && this.data6 && this.data7 && this.data8
      // ECFOP: le abilità (una o più) sono obbligatorie
      var okabil = !this.ECFOP || !this.progid || this.selabil.length >= 1
      // console.log("validvoto")
      return this.data && this.voto != "" && this.oggetto && this.oggetto != "" && ok && okabil;
    },
    validvotohome: function() {
      // ECFOP: le abilità (una o più) sono obbligatorie
      var okabil = !this.ECFOP || !this.progid || this.selabil.length >= 1
      return this.data && this.voto != "" && this.oggetto && this.oggetto != "" && okabil;
    },
    // ECFOP: raggruppa l'array piatto di abilità (registro.selabilprog) in
    // Aree → Competenze → Abilità e lo appiattisce in righe pronte per la tabella
    // a 3 colonne con rowspan (Area e Competenza una sola volta, centrate).
    abilitaRighe: function() {
      var aree = [];
      var idxArea = {};
      var compByKey = {};
      for (var i = 0; i < this.abilita.length; i++) {
        var ab = this.abilita[i];
        var an = ab.areanome || "";
        if (!(an in idxArea)) {
          idxArea[an] = aree.length;
          aree.push({ area: an, competenze: [] });
        }
        var area = aree[idxArea[an]];
        var ckey = an + "|" + ab.modcompid;
        var comp = compByKey[ckey];
        if (!comp) {
          comp = { modcompid: ab.modcompid, competenza: ab.competenza, abilita: [] };
          compByKey[ckey] = comp;
          area.competenze.push(comp);
        }
        comp.abilita.push(ab);
      }
      var righe = [];
      for (var a = 0; a < aree.length; a++) {
        var totArea = 0;
        for (var c = 0; c < aree[a].competenze.length; c++)
          totArea += aree[a].competenze[c].abilita.length;
        for (var c2 = 0; c2 < aree[a].competenze.length; c2++) {
          var comp2 = aree[a].competenze[c2];
          for (var b = 0; b < comp2.abilita.length; b++) {
            righe.push({
              area: aree[a].area,
              competenza: comp2.competenza,
              ab: comp2.abilita[b],
              rowspanArea: b === 0 && c2 === 0 ? totArea : 0,
              rowspanComp: b === 0 ? comp2.abilita.length : 0
            });
          }
        }
      }
      return righe;
    }
  },
  methods: {
    mindata: function(){
      // la routine si mangia un giorno, uno lo aggiungo e uno per abbondare
      let ret
      if(window.FORMVOTIALUNNI_PRIMOSEMESTRE==1) {
        ret = DateTime.fromISO(window.FORMVOTIALUNNI_dpickerannomin + '-09-01T00:00:00Z').toISODate()+'T00:00:00Z'
      } else {
        ret =  DateTime.fromISO(window.FORMVOTIALUNNI_DATAFINESEM+'T00:00:00Z').plus({ days: 2 }).toISODate()+'T00:00:00Z'
      }
      return ret
    },
    setdwhat() {
      Object.keys(this.dwtempl).forEach(k => (this.dwhat[k] = this[k]));
    },
    getdwhat() {
      Object.keys(this.dwtempl).forEach(k => (this[k] = this.dwhat[k]));
      // ECFOP: se il payload non porta abilità (es. nuovo voto), assicuro un array
      if (!Array.isArray(this.selabil)) this.selabil = [];
      console.log("DATA:",this.data)
      if(this.data)
        this.data = this.data + "T00:00:00Z"
      else
        this.data = DateTime.local().toISODate() + "T00:00:00Z"
      console.log("DATA2:",this.data)
    },
    async checkmsg() {
      if (!this.data) return;
      var mid = this.dwhat.mid;
      var d = this.data.split("T")[0];
      var ret = await API.sqlprep(this, "insvoto.selpdescr",[mid,d]);
      if (ret.data.dati.length > 0) {
        this.oggetto = JSON.parse(ret.data.dati[0].descrizione).default;
      }
    },
    // ECFOP: carica l'elenco delle abilità disponibili per il progetto.
    // Il parametro `tok` evita che una risposta in ritardo (apertura precedente
    // o cambio progetto) sovrascriva lo stato attuale della dialog.
    async loadabil(tok) {
      if (!this.ECFOP || !this.progid) return;
      if (this.abilprogid === this.progid && this.abilita.length) return; // già caricato
      this.abilita = [];
      this.loadingabil = true;
      var ret = await API.sqlprep(this, "registro.selabilprog", [this.progid, this.progid]);
      if (tok !== undefined && tok !== this.abiltoken) return; // risposta vecchia: ignora
      this.abilita = ret.data.dati || [];
      this.abilprogid = this.progid;
      this.loadingabil = false;
    },
    async addvoto(hm) {
      console.log("EMIT...");
      this.setdwhat(); // copia voto/oggetto/selabil/data1-8 locali in this.dwhat
      this.dwhat.hm = hm;
      this.dwhat.cancel = false;
      if(this.dwhat.oldvoto) 
        this.dwhat.update = true
      this.$emit("input", this.dwhat); // questo emit si aggancia come v-model
      this.lastOggettoData = this.data
      this.lastOggetto = this.oggetto
      this.lastOggettoModulo = this.currMod
    }
  }
};
</script>
<style scoped>
th.punti {
  font-size: x-small;
  text-align: center;
  vertical-align: middle;
}
td.punti {
  text-align: center;
}
th.punti1 {
  text-align: center;
  vertical-align: top;
  color: red;
}
th.punti2 {
  text-align: center;
  vertical-align: top;
  color: orange;
}
th.punti3 {
  text-align: center;
  vertical-align: top;
  color: green;
}
th.punti4 {
  text-align: center;
  vertical-align: top;
  color: lightseagreen;
}
.voto2 {
  font-size: x-large;
  width: 60px;
  text-align: right;
  background-color: lightgreen;
  display: inline-block;
  border-style: ridge;
}
.datavoto2 {
  font-size: x-large;
  width: 200px;
  display: inline-block;
  border-style: ridge;
  text-align: center;
}
.fa-check,
fa-home {
  color: green;
}
.abilita-box {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px;
  margin-top: 4px;
}
.abilita-item {
  display: block;
  font-weight: normal;
  margin-bottom: 4px;
}
.abilita-item input {
  margin-right: 6px;
}
.abilita-cdr span {
  margin-left: 4px;
}
.abilita-tabella {
  width: 100%;
  border-collapse: collapse;
}
.abilita-tabella th,
.abilita-tabella td {
  border: 1px solid #ddd;
  padding: 4px 6px;
  text-align: left;
  vertical-align: top;
}
.abilita-tabella th {
  font-weight: bold;
  background: #f5f5f5;
}
.abilita-tabella td.abilita-area {
  width: 18%;
  font-weight: bold;
}
.abilita-tabella td.abilita-comp {
  width: 40%;
}
.abilita-tabella .abilita-item {
  display: inline;
  margin-bottom: 0;
}
</style>